export default function LocationSection() {
  return (
    <section className="py-24 bg-[#F0F8FF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-0 bg-white rounded-3xl overflow-hidden shadow-2xl">
          {/* Left Panel - Location */}
          <div className="bg-[#F0F8FF] p-12 flex flex-col justify-between relative">
            <div>
              <div className="mb-8">
                <span className="text-gray-500 text-xs font-medium tracking-wider">VISIT US IN KERRVILLE</span>
              </div>
              <address className="not-italic">
                <h4 className="text-5xl font-bold text-gray-900 leading-tight mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  243 La Reata Rd S
                </h4>
                <h4 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Kerrville, TX
                </h4>
                <h4 className="text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
                  78028
                </h4>
              </address>
            </div>

            {/* Embedded Map */}
            <div className="w-full h-80 rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.3907410881734!2d-99.19797948945454!3d30.025645974828446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86595803de22af6f%3A0x2180eb73e531068!2sWest%20Insurance!5e0!3m2!1sen!2sus!4v1773794402490!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="West Insurance location map - 243 La Reata Rd S, Kerrville, TX 78028"
              ></iframe>
            </div>

            {/* Contact Info */}
            <div className="mt-8 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#0077B6] rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Phone</p>
                  <a href="tel:830-203-6201" className="text-base font-semibold text-gray-900 hover:text-[#0077B6] cursor-pointer">
                    830-203-6201
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#0077B6] rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Hours</p>
                  <p className="text-base font-semibold text-gray-900">Open 24/7</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Panel - CTA */}
          <div className="bg-white p-12 flex flex-col justify-center items-center text-center">
            <h4 className="text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ready for Better
              <br />
              Health Coverage?
            </h4>
            <p className="text-gray-600 text-base leading-relaxed mb-10 max-w-md">
              Contact <strong>West Insurance</strong> today for personalized health insurance quotes and expert guidance. 
              Our Kerrville team is ready to help you find the perfect private health insurance, group coverage, 
              or Medicare plan for your needs in Kerr County.
            </p>
            <a
              href="tel:830-203-6201"
              className="inline-flex items-center gap-2 px-10 py-4 bg-[#0077B6] text-white text-base font-semibold rounded-full hover:bg-[#005F8C] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Call 830-203-6201
              <i className="ri-arrow-right-line"></i>
            </a>
            <div className="mt-8 pt-8 border-t border-gray-200 w-full">
              <p className="text-sm text-gray-500 mb-4">Or get directions</p>
              <a
                href="https://www.google.com/maps/dir//243+La+Reata+Rd+S,+Kerrville,+TX+78028"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#0077B6] font-semibold text-sm hover:underline cursor-pointer"
              >
                <i className="ri-map-pin-line"></i>
                Get Directions to Our Office
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
